/**
 * AllSpaces Icon — "Alle" Life Space
 *
 * Bucket/tray icon from Figma design.
 * Compatible with Lucide icon API (size + color props).
 *
 * @example
 * <AllSpacesIcon size={16} />
 */
export const AllSpacesIcon = ({ size = 16, color }: { size?: number; color?: string }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.66 0.67H2.67"
        stroke={color || 'currentColor'}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.66 3.67H0.67L2.67 13.66H13.66L15.66 3.67Z"
        stroke={color || 'currentColor'}
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
